const DEFAULT_MESSAGES = {};
export function createTranslator(locale = 'en', resources = {}) {
    const table = { ...(DEFAULT_MESSAGES[locale] || {}), ...(resources[locale] || {}) };
    const fallback = { ...(DEFAULT_MESSAGES.en || {}), ...(resources.en || {}) };
    return (key, fallbackText) => table[key] || fallback[key] || fallbackText || key;
}
//# sourceMappingURL=i18n.js.map